import type { FieldValues, UseFormHandleSubmit, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { Button } from 'components/common';
import { Text } from 'components/forms';
import type { FormError } from 'components/forms/types';
import { format } from 'libs';

interface ProfileDetailsFormProps {
  errors: {
    email?: FormError;
    name?: FormError;
    phone_number?: FormError;
  };
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  isSubmitting?: boolean;
  onSubmit: (formValues: FieldValues) => void;
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
}

const ProfileDetailsForm = ({
  errors,
  handleSubmit,
  isSubmitting,
  onSubmit,
  register,
  setValue,
}: ProfileDetailsFormProps) => (
  <form className="py-4" onSubmit={handleSubmit(onSubmit)}>
    <div className="py-4">
      <Text error={errors.name} label="Name *" name="name" register={register('name')} type="text" />
      <Text error={errors.email} label="Email *" name="email" register={register('email')} type="email" />
      <Text
        error={errors.phone_number}
        label="Phone"
        name="phone_number"
        register={register('phone_number', {
          onChange: (event) => {
            setValue('phone_number', format.phoneNormalize(event.target.value));
          },
        })}
        type="text"
      />
    </div>
    <Button disabled={isSubmitting} submit variant="primary-dark" width="block">
      Continue
    </Button>
  </form>
);

export default ProfileDetailsForm;
